import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { BASE_KEY } from './backgroundKeys';
import { useTranslation } from 'react-i18next';

export interface IDeleteBackgroundParams {
  id: number;
}

export const deleteBackground = async (
  params: IDeleteBackgroundParams
): Promise<void> => {
  const { id } = params;
  await EXPRESS_API.delete(`/backgrounds/${id}`);
};

export const useDeleteBackgroundMutation = (onSuccess?: () => void) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { showError } = useToastError();

  return useMutation(deleteBackground, {
    onSuccess: async () => {
      await queryClient.refetchQueries({
        queryKey: BASE_KEY,
        exact: false,
      });
      onSuccess?.();
      successToast({
        title: t(`Background has been successfully deleted!`),
      });
    },
    onError: error =>
      showError(
        error || t(`An error occurred while trying to delete the background.`)
      ),
  });
};
